import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.scss";
import { useTranslation } from 'react-i18next';  // If you need translations in App.js
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ApiRoutes } from "./config/ApiRoutes";
import { setStoreData,getStoreLanguage } from "./helpers/userData";
import { getTotalQty } from "./helpers/cartData";
import {
  fetchFromServer,
} from "./helpers/ApiHelper";

import { PrivateRoute, OnlyPublicRoute } from "./helpers/userData";
import Loader from "./components/Loader";
import { Helmet } from 'react-helmet';

const OrdersDetailsView = lazy(() => import("./views/account/OrdersDetails"));
const DashboardView = lazy(() => import("./views/account/Dashboard"));
const ChangePasswordView = lazy(() => import("./views/account/ChangePassword"));
const SignInView = lazy(() => import("./views/account/SignIn"));
const SignUpView = lazy(() => import("./views/account/SignUp"));
const ForgotPasswordView = lazy(() => import("./views/account/ForgotPassword"));
const OrdersView = lazy(() => import("./views/account/Orders"));
const AddressesView = lazy(() => import("./views/account/Addresses"));
const ResetPasswordView = lazy(() => import("./views/account/ResetPassword"));
const ProductListView = lazy(() => import("./views/product/List"));
const ProductDetailView = lazy(() => import("./views/product/Detail"));
const CartView = lazy(() => import("./views/cart/Cart"));
const CheckoutView = lazy(() => import("./views/cart/Checkout"));
const ThankyouView = lazy(() => import("./views/cart/Thankyou"));
const NotFoundView = lazy(() => import("./views/pages/404"));
const InternalServerErrorView = lazy(() => import("./views/pages/500"));

function App() {
  const { t, i18n } = useTranslation(); // Use i18n hook to get translations and language change functions
  const [qty, setQty] = useState(getTotalQty());
  const [storeInfo, setStoreInfo] = useState({});
  const [loader, setLoader] = useState(true);
  const [languages, setLanguages] = useState([]);
  const [defaultLang, setDefaultLang] = useState('en-US'); // Default to 'en-US'
  useEffect(async () => {
   //await getVerifyDomain("velvet");
    let host = window.location.host;
    let parts = host.split(".");
    let subdomain = "";

    if (parts.length >= 1 || subdomain !== '') {
      subdomain = parts[0];
      console.log("subdomain", subdomain);
      // Remove the subdomain from the parts list
      parts.splice(0, 1);
      await getVerifyDomain(subdomain);
      // Set the location to the new url
    } else {
      console.log("error");
    //  window.location.href = '/404';
       window.location.href = "https://ekikart.com";
      //setPageLoading(false);
    }
    // eslint-disable-next-line
  }, []);
 // Handle language change from dropdown or other UI elements
 const handleLanguageChange = (lang) => {
  console.log('handleLanguageChange',lang)
  i18n.changeLanguage(lang); // This will switch the language dynamically
  setDefaultLang(lang);
};


  const getVerifyDomain = async (subdomain) => {
    const response = await fetchFromServer(
      ApiRoutes.VERIFY_STORE.service,
      ApiRoutes.VERIFY_STORE.url,
      ApiRoutes.VERIFY_STORE.authenticate,
      ApiRoutes.VERIFY_STORE.method,
      { slug: subdomain }
    );
    if (response.success === 1) {

      setStoreInfo(response.response);
      setLoader(false);
      setStoreData(response.response);
      const storeLanguage = getStoreLanguage();
      const selectedLanguage = storeLanguage || 'en-US';
      setDefaultLang(selectedLanguage);
      setLanguages([selectedLanguage]); // Set available languages based on API

      // Initialize i18next with the selected language
      i18n.changeLanguage(selectedLanguage);

      console.log('selectedLanguage',selectedLanguage);

      // response.data.data.subdomain = subdomain;
      // await setCampaignUserData(response.data.data);
      // setBrandData(response.data.data);
      // setPageLoading(false);
    } else {
      //console.log("error1",response);
     // navigate('/404');
     window.location.href = "https://ekikart.com";
      // window.location.href = process.env.REACT_FRONT_WEBSITE_URL;
    }
  };

  return (
    <>
      <Helmet>
        <title>{storeInfo?.storeDetails?.organizationName}</title>
      </Helmet>
      {loader ? <Loader vhCenter /> :
      <BrowserRouter>
        <React.Fragment>        
          <Header storeInfo={storeInfo} qty={qty}  onLanguageChange={handleLanguageChange} />
          <main className={`py-5 bg-fafafa`}>
            <Suspense
              fallback={
                <Loader />
              }
            >
              {/* <Routes>
                <Route exact path="/account/signin" element={<SignInView />} />
                <Route exact path="/account/signup" element={<SignUpView />} />
                <Route exact path="/account/forgotpassword" element={<ForgotPasswordView />} />
                <Route exact path="/account/dashboard/orders" element={<OrdersView />} />
                <Route exact path="/account/dashboard/order/details" element={<OrdersDetailsView />} />
                <Route exact path="/account/dashboard" element={<DashboardView />} />
                <Route exact path="/account/dashboard/changepassword" element={<ChangePasswordView />} />
                <Route exact path="/" element={<ProductListView />} />
                <Route exact path="/product/detail/:id" element={<ProductDetailView />} />
                <Route exact path="/cart" element={<CartView setQty={setQty} />} />
                <Route exact path="/checkout" element={<CheckoutView setQty={setQty} />} />
                <Route exact path="/thankyou" element={<ThankyouView />} />
                <Route exact path="/500" element={<InternalServerErrorView />} />
                <Route path="*" element={<NotFoundView />} />
              </Routes> */}
              <Routes>
                {/* Public Routes */}
                <Route exact path="/" element={<ProductListView />} />
                <Route exact path="/product/detail/:id" element={<ProductDetailView />} />
                <Route exact path="/cart" element={<CartView setQty={setQty} />} />
                <Route exact path="/checkout" element={<CheckoutView setQty={setQty} />} />
                <Route exact path="/thankyou/:id" element={<ThankyouView />} />

                <Route exact path="/account/signin" element={
                  <OnlyPublicRoute>
                    <SignInView />
                  </OnlyPublicRoute>
                } />

                <Route exact path="/account/signup" element={
                  <OnlyPublicRoute>
                    <SignUpView />
                  </OnlyPublicRoute>
                } />
                <Route exact path="/account/forgotpassword" element={
                  <OnlyPublicRoute>
                    <ForgotPasswordView />
                  </OnlyPublicRoute>
                } />

                <Route exact path="/account/resetPassword" element={
                  <OnlyPublicRoute>
                    <ResetPasswordView />
                  </OnlyPublicRoute>
                } />
                <Route
                  exact
                  path="/account/dashboard"
                  element={
                    <PrivateRoute>
                      <DashboardView />
                    </PrivateRoute>
                  }
                />
                <Route
                  exact
                  path="/account/dashboard/orders"
                  element={
                    <PrivateRoute>
                      <OrdersView />
                    </PrivateRoute>
                  }
                />
                <Route
                  exact
                  path="/account/dashboard/order/details/:id"
                  element={
                    <PrivateRoute>
                      <OrdersDetailsView />
                    </PrivateRoute>
                  }
                />
                <Route
                  exact
                  path="/account/dashboard/changepassword"
                  element={
                    <PrivateRoute>
                      <ChangePasswordView />
                    </PrivateRoute>
                  }
                />

                <Route exact path="/500" element={<InternalServerErrorView />} />
                <Route exact path="/400" element={<NotFoundView />} />
                <Route path="*" element={<NotFoundView />} />
              </Routes>
            </Suspense>
          </main>
          <Footer storeInfo={storeInfo} />
        </React.Fragment>
      </BrowserRouter>} </>
  );
}

export default App;
